module.exports = __webpack_public_path__ + "static/media/1.de9a18f6.jpg";